// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__29Oyr","resendInfoText":"OnGoingPaymentBox_resendInfoText__poq7D"};